/**
 * shared/hooks/usePageTitle.js
 * Sets the browser tab title. Shared across all frontends.
 * Identical to src/utils/usePageTitle.js.
 */
import { useEffect } from "react";

export default function usePageTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | Urba Mart` : "Urba Mart";
    return () => {
      document.title = prev;
    };
  }, [title]);
}
